import { useBoundStore } from '@Store/useBoundStore';
import { HttpService } from '..';
import { SaveOwnerBody } from '@Types/owner';
import { UboResponse } from '@Store/index';

export const saveOwner = async (body: SaveOwnerBody) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const {
    customerId,
    customerData: {
      customerBusinessData: { externalId: businessId },
    },
  } = useBoundStore.getState().customer;

  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessId}/ubo`
    : `v2/secureonboarding/user/${customerId}/business/${businessId}/ubo`;

  const { data } = await HttpService.post<{
    allowEditing: string;
    externalId: string;
    ownershipPercent: number;
  }>(url, body);
  return data;
};

export const getBusinessOwner = async (id: string) => {
  const businessExternalId =
    useBoundStore.getState().customer.customerData.customerBusinessData.externalId;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessExternalId}/ubo`
    : `v2/secureonboarding/user/${customerId}/business/${businessExternalId}/ubo`;

  const { data } = await HttpService.get<{ uboResponseList: UboResponse[] }>(url);
  const uboList = data?.uboResponseList;
  const ubo = uboList.find((owner) => owner.externalId === id);

  return ubo;
};
